import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./home";
import Login from "./Login";
import Register from "./Register";

import DashboardLayout from "./layout/Dashboardlayout";
import Dashboard from "./Dashboard";
import ApiKey from "./api/ApiKey";
import RcNormal from "./rc/RcNormal";
import RcFull from "./rc/RCFULL";
// import Wallet from "./Wallet";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 🌐 Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* 🔐 Dashboard Routes (Nested) */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="api-key" element={<ApiKey />} />
          <Route path="rc-normal" element={<RcNormal />} />
          <Route path="rcfull" element={<RcFull />} />
          {/* <Route path="wallet" element={<Wallet />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
